import gql from 'graphql-tag';

export const CREATE_USER = gql`
	mutation createUserMutation($input: CreateUserInput!) {
		createUser(input: $input) {
			id
			firstname
			lastname
			username
			phone
			role {
				id
				name
				permissions
			}
			excludeFromSelectors
			hideNames
		}
	}
`;

